/**
 * /admin/aes-sync-log — AES (TrustFactory) synced-data verification (route shell).
 * Screen impl in `./aes-sync-log-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/aes-sync-log')({
  component: lazyRouteComponent(
    () => import('./aes-sync-log-screen'),
    'AdminAesSyncLog',
  ),
});
